//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PriceProvidersRepository
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F)
 */
export const priceProvidersRepositoryAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_quoteToken', internalType: 'address', type: 'address' },
      { name: '_siloRepository', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AssetNotSupported' },
  { type: 'error', inputs: [], name: 'InvalidPriceProvider' },
  { type: 'error', inputs: [], name: 'InvalidPriceProviderQuoteToken' },
  { type: 'error', inputs: [], name: 'InvalidRepository' },
  { type: 'error', inputs: [], name: 'ManagerDidNotChange' },
  { type: 'error', inputs: [], name: 'ManagerIsZero' },
  { type: 'error', inputs: [], name: 'OnlyManager' },
  { type: 'error', inputs: [], name: 'OnlyOwnerOrManager' },
  { type: 'error', inputs: [], name: 'OnlyRepository' },
  { type: 'error', inputs: [], name: 'PriceProviderAlreadyExists' },
  { type: 'error', inputs: [], name: 'PriceProviderDoesNotExist' },
  { type: 'error', inputs: [], name: 'PriceProviderNotRegistered' },
  { type: 'error', inputs: [], name: 'QuoteTokenNotSupported' },
  { type: 'error', inputs: [], name: 'TokenIsNotAContract' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'manager',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'ManagerChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newPriceProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'NewPriceProvider',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newPendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipPending',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'priceProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PriceProviderForAsset',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'priceProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PriceProviderRemoved',
  },
  {
    type: 'function',
    inputs: [],
    name: 'QUOTE_TOKEN_DECIMALS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_provider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    name: 'addPriceProvider',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_manager', internalType: 'address', type: 'address' }],
    name: 'changeManager',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'getPrice',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_provider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    name: 'isPriceProvider',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'manager',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'priceProviders',
    outputs: [
      { name: '', internalType: 'contract IPriceProvider', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProvidersRepositoryPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'providerList',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'providersCount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'providersReadyForAsset',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quoteToken',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'removePendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_provider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    name: 'removePriceProvider',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_provider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    name: 'setPriceProviderForAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloRepository',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'transferPendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F)
 */
export const priceProvidersRepositoryAddress = {
  1: '0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x7C2ca9D502f2409BeceAfa68E97a176Ff805029F)
 */
export const priceProvidersRepositoryConfig = {
  address: priceProvidersRepositoryAddress,
  abi: priceProvidersRepositoryAbi,
} as const
